import { useState } from "react";
import BaseNativeAppContainer from "../base-native-app-container/BaseNativeAppContainer";
import Styles from "./XCode.module.scss";
import DropDown from "../drop-down/DropDown";
import { APP_KEY_IDS } from "../../constants/constants";
import Loader from "../loader/Loader";


const XCode = () => {

  const [language, setLanguage] = useState(0)

  const changeLanguage = (index: number) => {
    setLanguage(index)
  }

  const languages = [
    {
      id: 0,
      label: "HTML",
      link: "https://trinket.io/embed/html/05e679f15c"
    },
    {
      id: 1,
      label: "GlowScript",
      link: "https://trinket.io/embed/glowscript-blocks/4a57b96809"
    },
    {
      id: 2,
      label: "Java",
      link: "https://trinket.io/embed/java/d27bab589d"
    },
    {
      id: 3,
      label: "Python",
      link: "https://trinket.io/embed/python/a642f32a4e?start=result"
    },
    {
      id: 4,
      label: "Python 3",
      link: "https://trinket.io/embed/python3/8288e3d01c"
    },
    {
      id: 5,
      label: "R",
      link: "https://trinket.io/embed/R/b1f1ed7a5f"
    }
  ]

  return (
    <BaseNativeAppContainer
      appId={APP_KEY_IDS.XCODE}
      loadFromX={30}
      title={"XCode"}
      height={554}
      MainScreen={
        <div className={Styles.container}>
          <div className={Styles.loader}>
            <Loader/>
          </div>
          <div className={Styles.code_container}>
            <iframe id="ide" className={Styles.ide} name="ide" src={languages[language].link} ></iframe>
          </div>
          <div className={Styles.bottom_line}>
            <div className={Styles.lnaguage_selector}>
              <div className={Styles.header}>
                Language -
              </div>
              <DropDown options={languages} selected={language} position="bottom" handleClick={changeLanguage} />
            </div>
          </div>
        </div>

      } />
  )
}

export default XCode
